import { DirectiveOptions } from 'vue';

const tableWrap: DirectiveOptions = {
    bind(el: HTMLElement): void {
        Array.from(el.querySelectorAll('table.desktop')).forEach((table) => {
            if (table.parentNode) {
                const wrapper = document.createElement('div');
                wrapper.classList.add('c-table-responsive-wrapper');
                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
        });
    },
};

export default tableWrap;
